module.exports = __webpack_public_path__ + "img/slate_pencil_urchin.e0a026ff.png";